export const translations = {
  ro: {
    common: {
      companyName: 'Younger Karom',
      language: 'Română',
      yes: 'Da',
      no: 'Nu',
      prev: 'Înapoi',
      next: 'Înainte',
    },
            food: 'Alimentare',
    nav: {
      home: 'Acasă',
      mission: 'Povestea Noastră',
      products: 'Produse',
      customMold: 'Sticla Ta Unică!',
      contact: 'Contact',
      catalog: 'Catalog',
      menu: 'Meniu',
    },
    mission: {
      title: 'Povestea Noastră',
      subtitle: 'Parcursul Younger Karom, marcat prin etapele noastre cheie.',
      ariaRoadmap: 'Roadmap Povestea Noastră',
      timeline: [
        {
          year: '1993',
          title: 'Începutul drumului',
          text:
            'Povestea companiei noastre începe în 1993, când activitatea era orientată în principal către comerț cu diverse bunuri, în special pentru industria alimentară. În acei ani am construit primele relații de parteneriat și am învățat să înțelegem nevoile reale ale pieței. Această perioadă ne-a format mentalitatea de astăzi: orientare către client, seriozitate și dorința de a construi relații durabile.',
        },
        {
          year: '1997',
          title: 'Primul pas spre producție',
          text:
            'După câțiva ani de experiență în comerț, pasiunea pentru ambalaje și dorința de a crea produse proprii ne-au făcut să facem pasul către producție. Am instalat prima linie de fabricație și am realizat primul nostru model de sticlă PET. A fost momentul în care ideea de a construi ceva cu mâinile noastre a devenit realitate și a pus bazele direcției pe care compania avea să o urmeze.',
        },
        {
          year: '2001',
          title: 'Inovație din pasiune',
          text:
            'Pasiunea pentru sticla perfectă și dorința de a controla fiecare detaliu al procesului de producție ne-au determinat să facem un pas îndrăzneț: am început să ne proiectăm și să ne construim propriile utilaje de suflat. Astfel am reușit să avem control deplin asupra fluxului nostru de producție și să adaptăm tehnologia exact nevoilor noastre. În aceeași perioadă am început să participăm la târguri și expoziții de profil, unde am avut ocazia să prezentăm atât utilajele dezvoltate de noi, cât și produsele realizate în fabrică.',
        },
        {
          year: '2004',
          title: 'Extindere',
          text:
            'Pe măsură ce cererea pentru produsele noastre a crescut, compania a intrat într-o etapă importantă de dezvoltare. Capacitatea de producție a ajuns la șase linii de fabricație, iar portofoliul s-a extins cu noi tipuri de ambalaje. Tot în această perioadă au fost realizate primele matrițe pentru recipiente de volum mare, inclusiv modele de 10 litri.',
        },
        {
          year: '2006',
          title: 'Personalizare',
          text:
            'Dorind să oferim clienților exact ambalajul de care au nevoie, am început să dezvoltăm sticle PET personalizate. Dorința de a ne vedea clienții mulțumiți și de a contribui la succesul produselor lor ne-a motivat să creăm ambalaje adaptate fiecărui domeniu de activitate, atât din punct de vedere tehnic, cât și estetic.',
        },
        {
          year: '2012',
          title: 'Diversificare',
          text:
            'Pentru a răspunde unor nevoi tot mai variate ale pieței, am decis să extindem portofoliul și către ambalaje fabricate din polietilenă (PE). Această etapă a marcat o nouă direcție de dezvoltare și ne-a permis să oferim soluții de ambalare pentru o gamă mai largă de aplicații industriale.',
        },
        {
          year: '2023',
          title: 'Energie verde',
          text:
            'După ani în care natura ne-a oferit resursele necesare pentru a crea ambalajele noastre, am simțit că este momentul să oferim ceva înapoi. Din grijă pentru mediul înconjurător și pentru generațiile viitoare, am început să integrăm energie verde în procesul nostru de producție prin instalarea de panouri solare care susțin activitatea fabricii.',
        },
        {
          year: '2026',
          title: 'Modernizare',
          text:
            'Astăzi continuăm să investim în tehnologie și eficiență. Liniile de producție sunt modernizate cu utilaje performante și compresoare eficiente energetic, astfel încât să putem produce ambalaje de calitate în condiții tot mai sustenabile. Modernizarea nu înseamnă doar echipamente noi, ci și dorința continuă de a face lucrurile mai bine în fiecare zi.',
        },
      ],
      roadmap: [
        {
          year: '1993',
          title: 'Începutul drumului',
          image: '1993_1.jpg',
          text:
            'Povestea companiei noastre începe în 1993, când activitatea era orientată în principal către comerț cu diverse bunuri, în special pentru industria alimentară. În acei ani am construit primele relații de parteneriat și am învățat să înțelegem nevoile reale ale pieței. Această perioadă ne-a format mentalitatea de astăzi: orientare către client, seriozitate și dorința de a construi relații durabile.',
        },
        {
          year: '1997',
          title: 'Primul pas spre producție',
          image: '1997_1.jpg',
          text:
            'După câțiva ani de experiență în comerț, pasiunea pentru ambalaje și dorința de a crea produse proprii ne-au făcut să facem pasul către producție. Am instalat prima linie de fabricație și am realizat primul nostru model de sticlă PET. A fost momentul în care ideea de a construi ceva cu mâinile noastre a devenit realitate și a pus bazele direcției pe care compania avea să o urmeze.',
        },
        {
          year: '2001',
          title: 'Inovație din pasiune',
          image: '2001_1.png',
          text:
            'Pasiunea pentru sticla perfectă și dorința de a controla fiecare detaliu al procesului de producție ne-au determinat să facem un pas îndrăzneț: am început să ne proiectăm și să ne construim propriile utilaje de suflat. Astfel am reușit să avem control deplin asupra fluxului nostru de producție și să adaptăm tehnologia exact nevoilor noastre. În aceeași perioadă am început să participăm la târguri și expoziții de profil, unde am avut ocazia să prezentăm atât utilajele dezvoltate de noi, cât și produsele realizate în fabrică.',
        },
        {
          year: '2004',
          title: 'Extindere',
          image: '2004_1.jpg',
          text:
            'Pe măsură ce cererea pentru produsele noastre a crescut, compania a intrat într-o etapă importantă de dezvoltare. Capacitatea de producție a ajuns la șase linii de fabricație, iar portofoliul s-a extins cu noi tipuri de ambalaje. Tot în această perioadă au fost realizate primele matrițe pentru recipiente de volum mare, inclusiv modele de 10 litri.',
        },
        {
          year: '2006',
          title: 'Personalizare',
          image: '2006_1.png',
          text:
            'Dorind să oferim clienților exact ambalajul de care au nevoie, am început să dezvoltăm sticle PET personalizate. Dorința de a ne vedea clienții mulțumiți și de a contribui la succesul produselor lor ne-a motivat să creăm ambalaje adaptate fiecărui domeniu de activitate, atât din punct de vedere tehnic, cât și estetic.',
        },
        {
          year: '2012',
          title: 'Diversificare',
          image: '2012_1.png',
          text:
            'Pentru a răspunde unor nevoi tot mai variate ale pieței, am decis să extindem portofoliul și către ambalaje fabricate din polietilenă (PE). Această etapă a marcat o nouă direcție de dezvoltare și ne-a permis să oferim soluții de ambalare pentru o gamă mai largă de aplicații industriale.',
        },
        {
          year: '2023',
          title: 'Energie verde',
          image: '2023_1.png',
          text:
            'După ani în care natura ne-a oferit resursele necesare pentru a crea ambalajele noastre, am simțit că este momentul să oferim ceva înapoi. Din grijă pentru mediul înconjurător și pentru generațiile viitoare, am început să integrăm energie verde în procesul nostru de producție prin instalarea de panouri solare care susțin activitatea fabricii.',
        },
        {
          year: '2026',
          title: 'Modernizare',
          image: '2026_1.png',
          text:
            'Astăzi continuăm să investim în tehnologie și eficiență. Liniile de producție sunt modernizate cu utilaje performante și compresoare eficiente energetic, astfel încât să putem produce ambalaje de calitate în condiții tot mai sustenabile. Modernizarea nu înseamnă doar echipamente noi, ci și dorința continuă de a face lucrurile mai bine în fiecare zi.',
        },
      ],
    },
    customMold: {
      title: 'Sticla Ta Unică!',
      cta: 'Mergi la Contact',
      heroLines: ['Nu ai', 'găsit', 'ce', 'voiai?'],
      infoLeadPrefix: 'Îți creăm',
      infoLeadStrong: 'designul personalizat gratuit',
      infoLeadSuffix: ', în funcție de cerințele tale tehnice și de brand.',
      bullets: [],
      bottomLine: 'Tu vii cu ideea, noi ne ocupăm de restul.',
    },
    home: {
      title: 'Din 1997, ambalaje din plastic pentru parteneriate durabile',
      subtitle:
        'Producem sticle PET și oferim o gamă completă de produse conexe pentru industria ambalajelor.',
      productionAppEyebrow: 'Platformă internă',
      productionAppText: 'Accesează aplicația de planificare a producției din același domeniu, pe un subpath separat.',
      productionAppCta: 'Deschide aplicația de producție',
      heroImageAlt: 'Sticlă PET prezentată pe pagina principală',
      highlightsTitle: 'Ce oferim',
      highlights: [
        'FLACOANE',
        'DOPURI',
        'MÂNERE',
        'PREFORME',
        'CASEROLE',
        'GĂLEȚI',
        'CANISTRE',
      ],
      greenImageAlt: 'Element vizual Younger Karom',
      ctaPrimary: 'Vezi produsele',
      ctaSecondary: 'Contactează-ne',
    },
    products: {
      title: 'Produse',
      intro:
      'Selectează din gama noastră de ambalaje și accesorii. Pentru detalii tehnice (capacități, gâturi, culori, cantități), contactează-ne.',
      back: 'Înapoi la produse',
      categoryBarTitle: 'Filtrează după categorie',
      preformsInfoTitle: 'Gramaje și culori variate',
      preformsInfoBody:
        'Comercializăm o gamă variată de preforme PET, disponibile în diferite gramaje, culori și configurații ale gâtului. Pentru oferta completă, disponibilitate și detalii tehnice, te rugăm să ne contactezi.',
      catalog: {
        comingSoonTitle: 'Produse',
        comingSoonBody:
          'Catalogul pentru această categorie este în curs de actualizare. Pentru o ofertă și detalii tehnice, contactează-ne.',
      },
      buckets: {
        bidon1L: { title: 'Bidon 1 L' },
        bidon1LNatur: { title: 'Bidon 1L Natur' },
        bidon1LGri: { title: 'Bidon 1L Gri' },
        bidon5L: { title: 'Bidon 5 L' },
        flacon075L: { title: 'Flacon 750 ml' },
        canistraEuro5L: { title: 'Canistră Euro 5 L' },
        canistraEuro10L: { title: 'Canistră Euro 10 L' },
        canistraEuro5_10L: { title: 'Canistră Euro 5L / 10L' },
        caserola012L: { title: 'Caserolă 120 ml' },
        caserola018L: { title: 'Caserolă 180 ml' },
        caserola037L: { title: 'Caserolă 370 ml' },
        caserola018_037L: { title: 'Caserolă 180ml / 370ml' },
        caserola052L: { title: 'Caserolă 520 ml' },
        galeata05L: { title: 'Găleată 500 ml' },
        galeata085L: { title: 'Găleată 850 ml' },
        galeata085_1L: { title: 'Găleată 850ml / 1000ml' },
        galeata1L: { title: 'Găleată 1 L' },
        galeata15L: { title: 'Găleată 1.5 L' },
        galeata12_15L: { title: 'Găleată 1.2L / 1.5L' },
        galeata3L: { title: 'Găleată 3 L' },
        galeata3_5_10_12L: { title: 'Găleată 3L / 5L / 10L / 12L' },
        galeataOval3L: { title: 'Găleată Oval 3L' },
        galeata5L: { title: 'Găleată 5 L' },
        galeata10L: { title: 'Găleată 10 L' },
        galeataPatrata10L: { title: 'Găleată pătrată 10 L' },
      },
      caps: {
        dop3025: { title: 'Dop 30/25' },
        dopPco1881: { title: 'Dop PCO 1881' },
        dopPco1810: { title: 'Dop PCO 1810' },
        dopProtectieCopiiPco1810: { title: 'Dop protecție copii PCO 1810' },
        dop3831: { title: 'Dop 38/31' },
        dopProtectieCopii3831: { title: 'Dop protecție copii 38/31' },
        dop4841: { title: 'Dop 48/41' },
        dopProtectieCopii4841: { title: 'Dop protecție copii 48/41' },
        dop2921: { title: 'Dop 29/21' },
        dopPushPull: { title: 'Dop Push-Pull' },
        manerePco38_31_48_41: { title: 'Mânere PCO, 38/31, 48/41' },
        pompaSapun: { title: 'Pompiță săpun' },
        trigger: { title: 'Trigger' },
      },
      filters: {
        title: 'Filtre',
        marketSegment: 'Segment de piață',
        industry: 'Industrie',
        neckType: 'Tip Filet',
        capacity: 'Volum (ml)',
        shape: 'Formă',
        sort: 'Sortare',
        from: 'De la (ml)',
        to: 'Până la (ml)',
        capacityHint: 'Selectează intervalul de volum (ml).',
        ctaButton: 'Trimite cerere cu aceste specificații',
        options: {
          sort: {
            implicit: 'Implicit',
            az: 'Alfabetic crescător (A→Z)',
            za: 'Alfabetic descrescător (Z→A)',
          },
          segments: {
            water: 'Apă',
            alcoholic: 'Bauturi alcoolice',
            beer: 'Bere',
            church: 'Biserică',
            chemicals: 'Chimicale',
            sportsdrink: 'Băuturi Sport',
            soap: 'Săpun',
            title: 'Dopuri & Mânere',
            cosmetics: 'Cosmetice',
            detergent: 'Detergent',
            pharma: 'Farmaceutice',
            fresh: 'Fresh & Smoothies',
            icetea: 'Ice-Tea',
            dairy: 'Lactate',
            vinegar: 'Oțet',
            nonalcoholic: 'Răcoritoare',
            syrups: 'Siropuri',
            oil: 'Ulei',
            wine: 'Vin',
          },
          neckTypes: {
            pco1881: 'PCO 1881',
            pco1810: 'PCO 1810',
            oil2921: '29/21',
            neck3025: '30/25',
            neck38mm: '38/31',
            neck48mm: '48/41',
          },
          shapes: {
            round: 'Rotundă',
            oval: 'Ovală',
            square: 'Pătrată',
            rectangular: 'Rectangulară',
          },
        },
      },
      search: {
        placeholder: 'Caută produs',
        suggestions: 'Sugestii produse',
        noResultsTitle: 'Nu am găsit produse',
        noResultsBody: 'Încearcă alt termen de căutare sau șterge căutarea pentru a vedea din nou toate produsele din categorie.',
      },
      detail: {
        ctaTitle: 'Cere o ofertă',
        ctaBody:
          'Spune-ne capacitatea, gâtul, culoarea și cantitatea dorită. Îți răspundem cât mai rapid cu o ofertă.',
        ctaButton: 'Mergi la Contact',
      },
      items: {
        petBottles: {
          title: 'Flacoane PET',
          desc: 'Flacoane PET pentru diverse utilizări și volume.',
        },
        preforms: {
          title: 'Preforme',
          desc: 'Preforme compatibile cu mai multe tipuri de gât și capace.',
        },
        capsHandles: {
          title: 'Dopuri & Mânere',
          desc: 'Dopuri și mânere pentru diferite aplicații și standarde.',
        },
        bucketsGallons: {
          title: 'Alte Produse',
          desc: 'Găleți și bidoane din plastic pentru uz industrial și comercial.',
        },
      },
      pet: {
        aboutTitle: 'Produs',
        sendRequest: 'Trimite cerere produs',
        downloadSketch: 'Descarcă schița produs',
        downloadTechSheet: 'Descarcă fișa tehnică (PDF)',
        similarTitle: 'Produse similare',
        listDisclaimer:
          'În funcție de necesitățiile dumneavoastră și de cantitatea cerută, flacoanele noastre pot fi realizate și în alte culori decât cele menționate pe site.',
        co2: {
          title: 'CO₂ Footprint',
          labels: {
            rpet: '30% rPET',
            pet: '100% PET',
            glass: 'Sticlă',
          },
          disclaimer:
            'Valorile afișate sunt estimări orientative, calculate pe baza greutății ambalajului și a unor factori medii de emisii pentru fiecare material. Nu reprezintă un studiu Life Cycle Assessment (LCA) complet și pot varia în funcție de compoziția materialului, consumul de energie în producție, transport și scenariul de reciclare.',
        },
        colors: {
          transparent: 'Transparent',
          white: 'Alb',
          black: 'Negru',
          blue: 'Albastru',
          green: 'Verde',
          amber: 'Chihlimbar',
          brown: 'Maro',
        },
        neckConnection: {
          snapOn: 'Snap-on',
        },
        specs: {
          fillVolume: 'Volum (ml)',
          weight: 'Greutate',
          material: 'Material',
          color: 'Culori disponibile',
          neckConnection: 'Conexiune gât',
          neckType: 'Tip filet',
          shape: 'Formă',
          diameter: 'Diametru',
          maxRecommendedLabelHeight: 'Înălțime maximă recomandată etichetă',
          labelSize: 'Dimensiune etichetă',
          labelSizeOnSketch: 'Informație pe schiță',
          shrinkSleeve: 'Etichetă shrink sleeve',
          shrinkSleeveCompatible: 'Design compatibil cu etichete shrink sleeve.',
          proposedIndustry: 'Industrie propusă',
          country: 'Țara de producție',
          moq: 'Comandă minimă',
        },
        products: {
          pet480Vinegar: {
            title: 'Sticlă PET 0.48L',
            desc:
              'Sticlă PET transparentă, potrivită pentru aplicații alimentare și fresh. Disponibilă cu filet 29/21 (Ulei) și formă rotundă.',
          },
          pet750Spray: {
            title: 'Sticlă PET 0.75L',
            desc:
              'Sticlă PET pentru aplicații chimicale/cosmetice/auto. Opțiuni de formă ovală și filet 28mm (PCO 1810).',
          },
          pet1000Detergent: {
            title: 'Sticlă PET 1.00L',
            desc:
              'Sticlă PET pentru detergenți și aplicații industriale. Formă rectangulară și opțiuni de gât 38mm.',
          },
          pet1500Oil: {
            title: 'Sticlă PET 1.50L',
            desc:
              'Sticlă PET pentru ulei și aplicații alimentare. Filet 29/21 (Ulei) și formă rotundă.',
          },
          milky500: {
            title: 'MILKY 0.50L',
            desc:
              'Sticlă PET MILKY pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          milky900: {
            title: 'MILKY 0.90L',
            desc:
              'Sticlă PET MILKY pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          milky1000: {
            title: 'MILKY 1.00L',
            desc:
              'Sticlă PET MILKY pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          laptic750: {
            title: 'LĂPTIC 0.75L',
            desc:
              'Sticlă PET LĂPTIC pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          karolacta330: {
            title: 'KAROLACTA 0.33L',
            desc:
              'Sticlă PET KAROLACTA pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          karolacta450: {
            title: 'KAROLACTA 0.45L',
            desc:
              'Sticlă PET KAROLACTA pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          karolacta500: {
            title: 'KAROLACTA 0.50L',
            desc:
              'Sticlă PET KAROLACTA pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          karolacta900: {
            title: 'KAROLACTA 0.90L',
            desc:
              'Sticlă PET KAROLACTA pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          baby250: {
            title: 'BABY 0.25L',
            desc:
              'Sticlă PET BABY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          baby350: {
            title: 'BABY 0.35L',
            desc:
              'Sticlă PET BABY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          baby400: {
            title: 'BABY 0.40L',
            desc:
              'Sticlă PET BABY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          baby500: {
            title: 'BABY 0.50L',
            desc:
              'Sticlă PET BABY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          baby1000: {
            title: 'BABY 1.00L',
            desc:
              'Sticlă PET BABY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          factory300: {
            title: 'FACTORY 0.30L',
            desc:
              'Sticlă PET FACTORY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          factory350: {
            title: 'FACTORY 0.35L',
            desc:
              'Sticlă PET FACTORY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          factory500: {
            title: 'FACTORY 0.50L',
            desc:
              'Sticlă PET FACTORY (pătrată) pentru lactate, sucuri și sosuri. Filet 38mm, material PET / rPET (la cerere).',
          },
          standard1000: {
            title: 'STANDARD 1.00L',
            desc:
              'Sticlă PET cilindrică STANDARD pentru băuturi, sosuri, oțet și chimicale. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          comuna500: {
            title: 'COMUNA 0.50L',
            desc:
              'Sticlă PET cilindrică COMUNA pentru băuturi, sosuri, oțet și chimicale. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          otet500: {
            title: 'OȚET 0.50L',
            desc:
              'Sticlă PET cilindrică OȚET pentru oțet, băuturi și utilizări alimentare/industriale. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          otet1000: {
            title: 'OȚET 1.00L',
            desc:
              'Sticlă PET cilindrică OȚET pentru oțet, băuturi și utilizări alimentare/industriale. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          cristal1000: {
            title: 'CRISTAL 1.00L',
            desc:
              'Sticlă PET cilindrică CRISTAL pentru băuturi și chimicale. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          perfect2000: {
            title: 'PERFECT 2.00L',
            desc:
              'Sticlă PET cilindrică PERFECT pentru siropuri, băuturi și aplicații pharma/cosmetice. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          rotund500: {
            title: 'ROTUND 0.50L',
            desc:
              'Sticlă PET cilindrică ROTUND pentru băuturi și aplicații chimicale/cosmetice. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          rotund1000: {
            title: 'ROTUND 1.00L',
            desc:
              'Sticlă PET cilindrică ROTUND pentru băuturi și aplicații chimicale/cosmetice. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          sapun500: {
            title: 'SĂPUN 0.50L',
            desc:
              'Sticlă PET cilindrică pentru săpun/cosmetice/chimicale. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          finete250: {
            title: 'FINEȚE 0.25L',
            desc:
              'Sticlă PET cilindrică FINEȚE pentru cosmetice/chimicale. Filet 28mm (PCO 1881), material PET / rPET (la cerere).',
          },
          smoothies250: {
            title: 'Smoothies 0.25L',
            desc:
              'Sticlă PET cilindrică Smoothies pentru fresh, băuturi răcoritoare, ice-tea și lactate. Filet 38mm, material PET / rPET (la cerere).',
          },
          flacon200: {
            title: 'FLACON 0.20L',
            desc:
              'Flacon PET cilindric pentru pharma/cosmetice/chimicale. Filet 28mm (PCO 1881) și 30/25, material PET / rPET (la cerere).',
          },
          picola100: {
            title: 'PICOLA 0.10L',
            desc:
              'Sticlă PET cilindrică PICOLA pentru pharma/cosmetice/chimicale. Filet 30/25, material PET / rPET (la cerere).',
          },
          avantaj3000: {
            title: 'AVANTAJ 3.00L',
            desc:
              'Sticlă PET pătrată AVANTAJ pentru industria auto/ulei/chimicale. Filet 48mm, material PET / rPET (la cerere).',
          },
          premium5000: {
            title: 'PREMIUM 5.00L',
            desc:
              'Sticlă PET pătrată PREMIUM pentru industria auto/chimicale. Filet 48mm, material PET / rPET (la cerere).',
          },
          damigeana5000: {
            title: 'DAMIGEANA 5.00L',
            desc:
              'Sticlă PET DAMIGEANA (5L) pentru vin. Filet 48mm, material PET / rPET (la cerere).',
          },
          jumbo10000: {
            title: 'JUMBO 10.00L',
            desc:
              'Sticlă PET cilindrică JUMBO pentru aplicații industriale/chimicale. Filet 48mm, material PET / rPET (la cerere).',
          },
        },
      },
    },
    contact: {
      title: 'Contact',
      intro:
        'Spune-ne ce produs cauți și ce specificații ai nevoie. Revenim cât mai rapid cu o ofertă.',
      prefill: {
        request: 'Solicitare ofertă',
        category: 'Categorie',
        neckType: 'Tip filet',
        capacity: 'Capacitate',
      },
      detailsTitle: 'Detalii de contact',
      detailsBody:
        'Pentru cereri de ofertă și întrebări, ne poți scrie direct sau poți folosi formularul.',
      addressLabel: 'Adresă',
      addressValue: 'Strada Paharnicul Turturea 12, Sector 2, București, România.',
      phoneLabel: 'Telefon',
      salesPhoneLabel: 'Telefon Vânzări',
      secretariatPhoneLabel: 'Telefon Secretariat',
      salesEmailLabel: 'Email Vânzări',
      secretariatEmailLabel: 'Email Secretariat',
      formTitle: 'Solicită o ofertă',
      form: {
        name: 'Nume',
        company: 'Companie',
        phone: 'Telefon',
        email: 'Email',
        message: 'Mesaj',
        sending: 'Se trimite…',
        submit: 'Trimite',
        note:
          'Formularul trimite solicitarea pe email (sau deschide aplicația de email dacă nu este configurat serviciul).',
      },
      status: {
        success: 'Mesaj trimis. Îți răspundem cât mai curând.',
        error: 'Nu am putut trimite mesajul. Te rugăm să încerci din nou.',
        requiredFieldsPrefix: 'Pentru a trimite mesajul, completează câmpurile:',
        requiredFields: 'Completează toate câmpurile: Nume, Companie, Telefon, Email și Mesaj.',
        notConfigured:
          'Trimiterea emailului nu este configurată încă. Completează cheile EmailJS în fișierul .env.local (vezi README.md).',
      },
    },
    legal: {
      privacyPolicy: 'Politica de confidentialitate',
      cookiePolicy: 'Politica de cookie-uri',
      cookieSettings: 'Setari cookie-uri',
    },
    cookiesConsent: {
      eyebrow: 'Confidentialitate si cookies',
      bannerTitle: 'Cookies necesare si analytics optionale',
      bannerBody:
        'Folosim stocari necesare pentru functionarea site-ului si analytics optionale doar cu acordul tau. Poti accepta, refuza sau modifica alegerea oricand.',
      necessaryTitle: 'Necesare',
      necessaryDescription:
        'Sunt folosite pentru limba selectata si pentru retinerea optiunii tale privind cookies.',
      analyticsTitle: 'Analytics',
      analyticsDescription:
        'Ne ajuta sa intelegem cum este folosit site-ul prin statistici si interactiuni agregate.',
      rejectOptional: 'Refuza analytics',
      customize: 'Personalizeaza',
      acceptAnalytics: 'Accepta analytics',
      settingsEyebrow: 'Setari cookies',
      modalTitle: 'Preferinte cookies',
      modalBody:
        'Poti pastra doar stocarile necesare sau poti activa analytics optionale. Poti reveni oricand asupra alegerii.',
      alwaysActive: 'Mereu activ',
      withdrawNote:
        'Daca retragi analytics dupa ce au fost acceptate, modificarea se aplica la urmatoarea reincarcare a paginii.',
      cancel: 'Anuleaza',
      savePreferences: 'Salveaza preferintele',
      close: 'Inchide',
    },
  },
  en: {
    common: {
      companyName: 'Younger Karom',
      language: 'English',
      yes: 'Yes',
      no: 'No',
      prev: 'Back',
      next: 'Next',
    },
    nav: {
      home: 'Home',
      mission: 'Our Mission',
      products: 'Products',
      customMold: 'Your Unique Bottle!',
      contact: 'Contact',
      catalog: 'Catalog',
      menu: 'Menu',
    },
    mission: {
      title: 'Our Mission',
      subtitle: 'The Younger Karom journey, highlighted by our key milestones.',
      ariaRoadmap: 'Our Mission roadmap',
      timeline: [
        {
          year: '1993',
          title: 'The Beginning of the Journey',
          text:
            'Our company story begins in 1993, when our activity was mainly focused on trading various goods, especially for the food industry. During those years, we built our first partnerships and learned to understand the real needs of the market. That period shaped the mindset we still have today: customer focus, reliability, and the desire to build long-lasting relationships.',
        },
        {
          year: '1997',
          title: 'The First Step Toward Production',
          text:
            'After a few years of experience in trade, our passion for packaging and our wish to create our own products led us to move into manufacturing. We installed our first production line and made our first PET bottle model. It was the moment when the idea of building something with our own hands became reality and laid the foundation for the direction the company would follow.',
        },
        {
          year: '2001',
          title: 'Innovation Driven by Passion',
          text:
            'Our passion for the perfect bottle and our desire to control every detail of production made us take a bold step: we began designing and building our own blowing machines. This gave us full control over our production flow and allowed us to adapt technology exactly to our needs. In the same period, we started attending trade fairs and exhibitions, where we had the opportunity to present both the machines developed by us and the products made in our factory.',
        },
        {
          year: '2004',
          title: 'Expansion',
          text:
            'As demand for our products grew, the company entered an important development stage. Production capacity reached six manufacturing lines, and the portfolio expanded with new packaging types. During this period, the first molds for large-volume containers were also produced, including 10-liter models.',
        },
        {
          year: '2006',
          title: 'Customization',
          text:
            'Wanting to offer clients exactly the packaging they needed, we started developing customized PET bottles. The desire to see our clients satisfied and to contribute to the success of their products motivated us to create packaging adapted to each field of activity, both technically and aesthetically.',
        },
        {
          year: '2012',
          title: 'Diversification',
          text:
            'To meet the increasingly diverse needs of the market, we decided to expand our portfolio to include polyethylene (PE) packaging. This stage marked a new direction of development and allowed us to provide packaging solutions for a wider range of industrial applications.',
        },
        {
          year: '2023',
          title: 'Green Energy',
          text:
            'After years in which nature provided the resources needed to create our packaging, we felt it was time to give something back. Out of care for the environment and future generations, we began integrating green energy into our production process by installing solar panels that support factory operations.',
        },
        {
          year: '2026',
          title: 'Modernization',
          text:
            'Today we continue to invest in technology and efficiency. Production lines are being modernized with high-performance equipment and energy-efficient compressors, so we can produce quality packaging under increasingly sustainable conditions. Modernization means not only new equipment, but also the continuous desire to do things better every day.',
        },
      ],
      roadmap: [
        {
          year: '1993',
          title: 'The beginning of the journey',
          image: '1993_1.jpg',
          text:
            'Our company story begins in 1993, when our activity focused mainly on trading various goods, especially for the food industry. During those years, we built our first partnerships and learned to understand the real needs of the market. That period shaped the mindset we still have today: customer focus, reliability, and the drive to build long-term relationships.',
        },
        {
          year: '1997',
          title: 'First step toward production',
          image: '1997_1.jpg',
          text:
            'After several years of experience in trade, our passion for packaging and the desire to create our own products led us toward manufacturing. We installed the first production line and produced our first PET bottle model. It was the moment when the idea of building something with our own hands became reality and set the direction the company would follow.',
        },
        {
          year: '2001',
          title: 'Innovation driven by passion',
          image: '2001_1.png',
          text:
            'Our passion for the perfect bottle and the desire to control every detail of production pushed us to take a bold step: we started designing and building our own blow-molding machines. This gave us full control over our production flow and allowed us to tailor technology exactly to our needs. In the same period, we began taking part in industry fairs and exhibitions, where we showcased both the machines we developed and the products made in our factory.',
        },
        {
          year: '2004',
          title: 'Expansion',
          image: '2004_1.jpg',
          text:
            'As demand for our products increased, the company entered an important growth stage. Production capacity reached six manufacturing lines, and the portfolio expanded with new types of packaging. During this period, we also produced our first molds for large-volume containers, including 10-liter models.',
        },
        {
          year: '2006',
          title: 'Customization',
          image: '2006_1.jpeg',
          text:
            'To provide customers with exactly the packaging they needed, we started developing custom PET bottles. Our desire to see customers satisfied and support the success of their products motivated us to create packaging tailored to each field of activity, both technically and aesthetically.',
        },
        {
          year: '2012',
          title: 'Diversification',
          image: '2012_1.png',
          text:
            'To respond to increasingly varied market needs, we decided to expand our portfolio with polyethylene (PE) packaging as well. This stage marked a new development direction and allowed us to deliver packaging solutions for a wider range of industrial applications.',
        },
        {
          year: '2023',
          title: 'Green energy',
          image: '2023_1.png',
          text:
            'After years in which nature provided the resources needed to create our packaging, we felt it was time to give something back. Out of care for the environment and future generations, we began integrating green energy into our production process by installing solar panels that support factory operations.',
        },
        {
          year: '2026',
          title: 'Modernization',
          image: '2026_1.png',
          text:
            'Today, we continue investing in technology and efficiency. Production lines are upgraded with high-performance equipment and energy-efficient compressors so we can produce quality packaging under increasingly sustainable conditions. Modernization means not only new equipment, but also the continuous drive to do things better every day.',
        },
      ],
    },
    customMold: {
      title: 'Your Unique Bottle!',
      cta: 'Go to Contact',
      heroLines: ["Didn't find", 'what you', 'needed?'],
      infoLeadPrefix: 'We create',
      infoLeadStrong: 'your custom design for free',
      infoLeadSuffix: ', based on your technical and brand requirements.',
      bullets: [],
      bottomLine: 'You bring the idea, we take care of the rest.',
    },
    home: {
      title: 'Since 1997, plastic packaging for lasting partnerships',
      subtitle:
        'We manufacture PET bottles and supply a complete range of related packaging products.',
      productionAppEyebrow: 'Internal platform',
      productionAppText: 'Open the production planning application from the same domain, on a separate subpath.',
      productionAppCta: 'Open production app',
      heroImageAlt: 'PET bottle shown on the home page',
      highlightsTitle: 'What we offer',
      highlights: [
        'BOTTLES',
        'CAPS',
        'HANDLES',
        'PREFORMS',
        'CONTAINERS',
        'BUCKETS',
        'CANISTERS',
      ],
      greenImageAlt: 'Younger Karom visual element',
      ctaPrimary: 'View products',
      ctaSecondary: 'Contact us',
    },
    products: {
      title: 'Products',
      intro:
        'Choose from our range of packaging and accessories. For technical details (volumes, neck finishes, colors, quantities), contact us.',
      back: 'Back to products',
      categoryBarTitle: 'Filter by category',
      preformsInfoTitle: 'Many weights and colors',
      preformsInfoBody:
        'We supply a wide range of PET preforms, available in different weights, colors and neck finish configurations. For the full offer, availability and technical details, please contact us.',
      catalog: {
        comingSoonTitle: 'Products',
        comingSoonBody:
          'The catalog for this category is being updated. For a quote and technical details, please contact us.',
      },
      filters: {
        title: 'Filters',
        marketSegment: 'Market segment',
        industry: 'Industry',
        neckType: 'Neck finish',
        capacity: 'Capacity',
        shape: 'Shape',
        sort: 'Sort',
        from: 'From (ml)',
        to: 'To (ml)',
        capacityHint: 'Select the volume range (ml).',
        ctaButton: 'Send request with these specs',
        options: {
          sort: {
            implicit: 'Default',
            az: 'Alphabetical ascending (A→Z)',
            za: 'Alphabetical descending (Z→A)',
          },
          segments: {
            water: 'Water',
            alcoholic: 'Alcoholic Beverages',
            beer: 'Beer',
            church: 'Church',
            chemicals: 'Chemicals',
            sportsdrink: 'Sports Drinks',
            soap: 'Soap',
            cosmetics: 'Cosmetics',
            detergent: 'Detergent',
            food: 'Food',
            pharma: 'Pharmaceuticals',
            fresh: 'Fresh & Smoothies',
            icetea: 'Ice-Tea',
            dairy: 'Dairy',
            vinegar: 'Vinegar',
            nonalcoholic: 'Non-Alcoholic Beverages',
            syrups: 'Syrups',
            oil: 'Oil',
            wine: 'Wine',
          },
          neckTypes: {
            pco1881: 'PCO 1881',
            pco1810: 'PCO 1810',
            oil2921: '29/21',
            neck3025: '30/25',
            neck38mm: '38/31',
            neck48mm: '48/41',
          },
          shapes: {
            round: 'Round',
            oval: 'Oval',
            square: 'Square',
            rectangular: 'Rectangular',
          },
        },
      },
      detail: {
        ctaTitle: 'Request a quote',
        ctaBody:
          'Tell us the volume, neck finish, color, and required quantity. We’ll get back to you with a quote as soon as possible.',
        ctaButton: 'Go to Contact',
      },
      items: {
        petBottles: {
          title: 'PET Bottles',
          desc: 'PET containers for multiple uses and volumes.',
        },
        preforms: {
          title: 'Preforms',
          desc: 'Preforms compatible with multiple neck finishes and caps.',
        },
        capsHandles: {
          title: 'Caps & Handles',
          desc: 'Caps and handles for different applications and standards.',
        },
        bucketsGallons: {
          title: 'Buckets & Gallons',
          desc: 'Plastic buckets and gallons for industrial and commercial use.',
        },
      },
      buckets: {
        bidon1L: { title: '1 L Can' },
        bidon1LNatur: { title: '1L Natural Can' },
        bidon1LGri: { title: '1L Grey Can' },
        bidon5L: { title: '5 L Can' },
        flacon075L: { title: '750 ml Flask' },
        canistraEuro5L: { title: 'Euro Canister 5 L' },
        canistraEuro10L: { title: 'Euro Canister 10 L' },
        canistraEuro5_10L: { title: 'Euro Canister 5L / 10L' },
        caserola012L: { title: '120 ml Container' },
        caserola018L: { title: '180 ml Container' },
        caserola037L: { title: '370 ml Container' },
        caserola018_037L: { title: '180ml / 370ml Container' },
        caserola052L: { title: '520 ml Container' },
        galeata05L: { title: '500 ml Bucket' },
        galeata085L: { title: '850 ml Bucket' },
        galeata085_1L: { title: '850ml / 1000ml Bucket' },
        galeata1L: { title: '1 L Bucket' },
        galeata15L: { title: '1.5 L Bucket' },
        galeata12_15L: { title: '1.2L / 1.5L Bucket' },
        galeata3L: { title: '3 L Bucket' },
        galeata3_5_10_12L: { title: '3L / 5L / 10L / 12L Bucket' },
        galeataOval3L: { title: 'Oval Bucket 3L' },
        galeata5L: { title: '5 L Bucket' },
        galeata10L: { title: '10 L Bucket' },
        galeataPatrata10L: { title: '10 L Square Bucket' },
      },
      search: {
        placeholder: 'Search product',
        suggestions: 'Product suggestions',
        noResultsTitle: 'No products found',
        noResultsBody: 'Try a different search term or clear the search to see all products in this category again.',
      },

      pet: {
        aboutTitle: 'Product',
        sendRequest: 'Send product request',
        downloadSketch: 'Download product sketch',
        downloadTechSheet: 'Download technical sheet (PDF)',
        similarTitle: 'Similar products',
        listDisclaimer:
          'Depending on your needs and requested quantity, our bottles can also be produced in colors other than those listed on the site.',
        co2: {
          title: 'CO₂ Footprint',
          labels: {
            rpet: '30% rPET',
            pet: '100% PET',
            glass: 'Glass',
          },
          disclaimer:
            'The values shown are indicative estimates calculated from packaging weight and average emission factors per material. They are not a full Life Cycle Assessment (LCA) study and may vary depending on material formulation, production energy mix, transport, and recycling/end-of-life scenario.',
        },
        colors: {
          transparent: 'Transparent',
          white: 'White',
          black: 'Black',
          blue: 'Blue',
          green: 'Green',
          amber: 'Amber',
          brown: 'Brown',
        },
        caps: {
          dop3025: { title: 'Cap 30/25' },
          dopPco1881: { title: 'Cap PCO 1881' },
          dopPco1810: { title: 'Cap PCO 1810' },
          dopProtectieCopiiPco1810: { title: "Child-proof cap PCO 1810" },
          dop3831: { title: 'Cap 38/31' },
          dopProtectieCopii3831: { title: 'Child-proof cap 38/31' },
          dop4841: { title: 'Cap 48/41' },
          dopProtectieCopii4841: { title: 'Child-proof cap 48/41' },
          dop2921: { title: 'Cap 29/21' },
          dopPushPull: { title: 'Push-Pull cap' },
          manerePco38_31_48_41: { title: 'Handles PCO, 38/31, 48/41' },
          pompaSapun: { title: 'Soap pump' },
          trigger: { title: 'Trigger' },
        },
        neckConnection: {
          snapOn: 'Snap-on',
        },
        specs: {
          fillVolume: 'Fill volume (ml)',
          weight: 'Weight',
          material: 'Material',
          color: 'Available colors',
          neckConnection: 'Neck connection',
          neckType: 'Neck type',
          shape: 'Shape',
          diameter: 'Diameter',
          maxRecommendedLabelHeight: 'Maximum recommended label height',
          labelSize: 'Label size',
          labelSizeOnSketch: 'Information on sketch',
          maxLabelSpace: 'Maximum label space',
          maxLabelSpaceValue: '-',
          shrinkSleeve: 'Shrink sleeve label',
          shrinkSleeveCompatible: 'Shrink sleeve label-compatible design.',
          proposedIndustry: 'Proposed industry',
          country: 'Country of production',
          moq: 'Minimum order quantity',
        },
        products: {
          pet480Vinegar: {
            title: 'PET Bottle 0.48L',
            desc:
              'Transparent PET bottle suitable for food and fresh applications. Available with 29/21 (Oil) neck type and a round shape.',
          },
          pet750Spray: {
            title: 'PET Bottle 0.75L',
            desc:
              'PET bottle for chemicals/cosmetics/automotive applications. Oval shape options and 28mm (PCO 1810) neck type.',
          },
          pet1000Detergent: {
            title: 'PET Bottle 1.00L',
            desc:
              'PET bottle for detergents and industrial applications. Rectangular shape and 38mm neck options.',
          },
          pet1500Oil: {
            title: 'PET Bottle 1.50L',
            desc:
              'PET bottle for oil and food applications. 29/21 (Oil) neck type and a round shape.',
          },
          milky500: {
            title: 'MILKY 0.50L',
            desc:
              'MILKY PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          milky900: {
            title: 'MILKY 0.90L',
            desc:
              'MILKY PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          milky1000: {
            title: 'MILKY 1.00L',
            desc:
              'MILKY PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          laptic750: {
            title: 'LĂPTIC 0.75L',
            desc:
              'LĂPTIC PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          karolacta330: {
            title: 'KAROLACTA 0.33L',
            desc:
              'KAROLACTA PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          karolacta450: {
            title: 'KAROLACTA 0.45L',
            desc:
              'KAROLACTA PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          karolacta500: {
            title: 'KAROLACTA 0.50L',
            desc:
              'KAROLACTA PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          karolacta900: {
            title: 'KAROLACTA 0.90L',
            desc:
              'KAROLACTA PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          baby250: {
            title: 'BABY 0.25L',
            desc:
              'BABY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          baby350: {
            title: 'BABY 0.35L',
            desc:
              'BABY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          baby400: {
            title: 'BABY 0.40L',
            desc:
              'BABY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          baby500: {
            title: 'BABY 0.50L',
            desc:
              'BABY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          baby1000: {
            title: 'BABY 1.00L',
            desc:
              'BABY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          factory300: {
            title: 'FACTORY 0.30L',
            desc:
              'FACTORY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          factory350: {
            title: 'FACTORY 0.35L',
            desc:
              'FACTORY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          factory500: {
            title: 'FACTORY 0.50L',
            desc:
              'FACTORY square PET bottle for dairy, juices and sauces. 38mm neck finish, PET / rPET material (on request).',
          },
          standard1000: {
            title: 'STANDARD 1.00L',
            desc:
              'STANDARD cylindrical PET bottle for beverages, sauces, vinegar and chemicals. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          comuna500: {
            title: 'COMUNA 0.50L',
            desc:
              'COMUNA cylindrical PET bottle for beverages, sauces, vinegar and chemicals. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          otet500: {
            title: 'OȚET 0.50L',
            desc:
              'OȚET cylindrical PET bottle for vinegar and food/industrial uses. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          otet1000: {
            title: 'OȚET 1.00L',
            desc:
              'OȚET cylindrical PET bottle for vinegar and food/industrial uses. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          cristal1000: {
            title: 'CRISTAL 1.00L',
            desc:
              'CRISTAL cylindrical PET bottle for beverages and chemicals. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          perfect2000: {
            title: 'PERFECT 2.00L',
            desc:
              'PERFECT cylindrical PET bottle for syrups, drinks and pharma/cosmetics uses. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          rotund500: {
            title: 'ROTUND 0.50L',
            desc:
              'ROTUND cylindrical PET bottle for beverages and chemicals/cosmetics. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          rotund1000: {
            title: 'ROTUND 1.00L',
            desc:
              'ROTUND cylindrical PET bottle for beverages and chemicals/cosmetics. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          sapun500: {
            title: 'SĂPUN 0.50L',
            desc:
              'Cylindrical PET bottle for soap/cosmetics/chemicals. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          finete250: {
            title: 'FINEȚE 0.25L',
            desc:
              'FINEȚE cylindrical PET bottle for cosmetics/chemicals. 28mm (PCO 1881) neck type, PET / rPET material (on request).',
          },
          smoothies250: {
            title: 'Smoothies 0.25L',
            desc:
              'Smoothies cylindrical PET bottle for fresh drinks, soft drinks, ice tea, and dairy. 38mm neck finish, PET / rPET material (on request).',
          },
          flacon200: {
            title: 'FLACON 0.20L',
            desc:
              'Cylindrical PET flacon for pharma/cosmetics/chemicals. 28mm (PCO 1881) and 30/25 neck finishes, PET / rPET material (on request).',
          },
          picola100: {
            title: 'PICOLA 0.10L',
            desc:
              'PICOLA cylindrical PET bottle for pharma/cosmetics/chemicals. 30/25 neck finish, PET / rPET material (on request).',
          },
          avantaj3000: {
            title: 'AVANTAJ 3.00L',
            desc:
              'AVANTAJ square PET bottle for automotive/oil/chemicals. 48mm neck finish, PET / rPET material (on request).',
          },
          premium5000: {
            title: 'PREMIUM 5.00L',
            desc:
              'PREMIUM square PET bottle for automotive/chemicals. 48mm neck finish, PET / rPET material (on request).',
          },
          damigeana5000: {
            title: 'DAMIGEANA 5.00L',
            desc:
              'DAMIGEANA PET bottle (5L) for wine. 48mm neck finish, PET / rPET material (on request).',
          },
          jumbo10000: {
            title: 'JUMBO 10.00L',
            desc:
              'JUMBO cylindrical PET bottle for industrial/chemical uses. 48mm neck finish, PET / rPET material (on request).',
          },
        },
      },
    },
    contact: {
      title: 'Contact',
      intro:
        'Tell us what product you need and your specs. We will get back with a quote as soon as possible.',
      prefill: {
        request: 'Quote request',
        category: 'Category',
        neckType: 'Neck finish',
        capacity: 'Capacity',
      },
      detailsTitle: 'Contact details',
      detailsBody:
        'For quote requests and questions, you can email us directly or use the form.',
      addressLabel: 'Address',
      addressValue: 'Strada Paharnicul Turturea 12, Sector 2, Bucharest, Romania.',
      phoneLabel: 'Phone',
      salesPhoneLabel: 'Sales Phone',
      secretariatPhoneLabel: 'Secretariat Phone',
      salesEmailLabel: 'Sales Email',
      secretariatEmailLabel: 'Secretariat Email',
      formTitle: 'Request a quote',
      form: {
        name: 'Name',
        company: 'Company',
        phone: 'Phone',
        email: 'Email',
        message: 'Message',
        sending: 'Sending…',
        submit: 'Send',
        note:
          'This form sends the request by email (or opens your email app if the service is not configured).',
      },
      status: {
        success: 'Message sent. We will reply soon.',
        error: 'Could not send the message. Please try again.',
        requiredFieldsPrefix: 'To send the message, please complete the following fields:',
        requiredFields: 'Please complete all fields: Name, Company, Phone, Email, and Message.',
        notConfigured:
          'Email sending is not configured yet. Add your EmailJS keys in .env.local (see README.md).',
      },
    },
    legal: {
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      cookieSettings: 'Cookie settings',
    },
    cookiesConsent: {
      eyebrow: 'Privacy and cookies',
      bannerTitle: 'Necessary cookies and optional analytics',
      bannerBody:
        'We use storage necessary for site operation and optional analytics only with your consent. You can accept, reject, or change your choice at any time.',
      necessaryTitle: 'Necessary',
      necessaryDescription:
        'Used for the selected language and for remembering your cookie choice.',
      analyticsTitle: 'Analytics',
      analyticsDescription:
        'Helps us understand how the website is used through statistics and aggregated interactions.',
      rejectOptional: 'Reject analytics',
      customize: 'Customize',
      acceptAnalytics: 'Accept analytics',
      settingsEyebrow: 'Cookie settings',
      modalTitle: 'Cookie preferences',
      modalBody:
        'You can keep only necessary storage or enable optional analytics. You can change your choice at any time.',
      alwaysActive: 'Always active',
      withdrawNote:
        'If you withdraw analytics after previously accepting them, the change applies on the next page reload.',
      cancel: 'Cancel',
      savePreferences: 'Save preferences',
      close: 'Close',
    },
  },
};
